const SvgArrowLeftGlyph = ({ width = 16, height = 16, ...props }) => (
  <svg width={width} height={height} viewBox='0 0 16 16' {...props}>
    <path d='M9.334 12a.665.665 0 01-.472-.195L5.53 8.472a.666.666 0 010-.943l3.333-3.333a.666.666 0 11.943.942L6.943 8l2.862 2.862A.666.666 0 019.334 12' />
  </svg>
);

export default SvgArrowLeftGlyph;
